/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-14 09:25:32
 */
 
import Api from "src/util/api";
import {PageDo, Result, ResultPageDo} from "src/types/base";
export declare namespace DataCompleteDOI {

	export interface RowDataI {
        addendum_time: string,
        addendum_user: string
        data_time: string
        device_name: string
        id: number
        [str: string]: any
	}

	export interface QueryRowDataParamsI extends PageDo {
        mn: string, start_time: string,end_time: string
    }
    

}
export default class DataCompleteApi {
	/**
	 * 查询列表
	 * @param {DataCompleteDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchLog(params: DataCompleteDOI.QueryRowDataParamsI):Promise<ResultPageDo<DataCompleteDOI.RowDataI[], { key: string; name: string; unit: string }[]>> {
		return Api.post('/monitor/addendum_log/query', {
            start_time: '', end_time: '',
            ...params
        })
    }
    
    static async searchComplete(params: {mn: string, device_id: number, start_time: number,end_time: number}):Promise<Result<{data_time: string, upload_rate: number}[]>> {
		return Api.post('/monitor/integrity_rate/data/query', params)
    }

    static async searchDataDetail(params: {mn: string, start_time: number, end_time: number}):Promise<ResultPageDo<any[],{id: string,key: string, name: string, unit: string}[]>> {
		return Api.post('/monitor/site_data/query', params)
    }

    static async handleComplete(params: {mn: string, device_name: string, data_info: any[]}):Promise<Result<any>> {
		return Api.post('/monitor/data/addendum', params)
    }
    static async longDistance(params: {mn: string, begintime: number, endtime: number}):Promise<Result<any>> {
		return Api.post('/countercharge/data/addendum/long_distance', params)
    }
    
}